import React from 'react';
import './ArrowsDown.css';

const ArrowsDown = () => {
  return (
    <a href="#skills" className="arrows">
      <div className="arrow marginv"></div>
      <div className="arrow marginv"></div>
      <div className="arrow marginv"></div>
    </a>
  );
};

export default ArrowsDown;
